import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/Person.css';

function Person() {
  window.scrollTo(0, 0);

  return (
     <div style={{ backgroundImage: 'url(/material/wand.jpg)', backgroundRepeat: 'repeat', minHeight: '100vh' }}>
      <Navigation />

      <div className="container py-5">
        {/* Persönliche Karte */}
        <div className="card shadow mb-5 mt-5">
          <div className="row g-0 align-items-center">
            <div className="col-md-4">
              <img src="/material/Profilbild2.jpg" className="img-fluid rounded-start" alt="Gerrit Helm" />
            </div>
            <div className="col-md-8">
              <div className="card-body">
                <h3 className="card-title">Dr. Gerrit Helm</h3>
                <p className="mb-2">Professionalisierung von Lehrkräften beim Schreiben im Kontext von KI</p>
                <p className="mb-2">Sprachdidaktische Modellierung des Lesens</p>
                <p className="mb-0">Lesediagnostik in der Primarstufe</p>
              </div>
            </div>
          </div>
        </div>

        {/* Beruflicher Werdegang */}
        <div className="card shadow mb-5 p-4">
          <h4 className="mb-4">Beruflicher Werdegang</h4>
          <div className="border-top pt-3">
            <div className="row mb-3">
              <div className="col-md-2 fw-bold">seit 2024</div>
              <div className="col-md-2">FSU Jena</div>
              <div className="col-md-8">Wissenschaftlicher Mitarbeiter an der FSU Jena (in den Projekten "Schreiben mit KI im Lehramt" (2024-25) und "SKILLS" (ab 2025)).</div>
            </div>
            <div className="row mb-3">
              <div className="col-md-2 fw-bold">WiSe '23 - SoSe '24</div>
              <div className="col-md-2">Uni Wuppertal</div>
              <div className="col-md-8">Mitarbeiter im drittmittelgeförderten Projekt 'Leseband_NRW' an der Bergischen Universität Wuppertal.</div>
            </div>
            <div className="row mb-3">
              <div className="col-md-2 fw-bold">SoSe '20 - WiSe '23</div>
              <div className="col-md-2">Uni Wuppertal</div>
              <div className="col-md-8">Wissenschaftlicher Mitarbeiter am Lehrstuhl für Lese- und Literaturdidaktik an der Bergischen Universität Wuppertal.</div>
            </div>
            <div className="row mb-3">
              <div className="col-md-2 fw-bold">SoSe '17 - WiSe '20</div>
              <div className="col-md-2">Uni Oldenburg</div>
              <div className="col-md-8">Wissenschaftlicher Mitarbeiter der Sprachdidaktik und Mitarbeiter im GHR300 (Praxisphase) an der Uni Oldenburg.</div>
            </div>
            <div className="row mb-3">
              <div className="col-md-2 fw-bold">WiSe 16/17</div>
              <div className="col-md-2">Uni Oldenburg</div>
              <div className="col-md-8">Lehrauftrag für English Linguistics an der Uni Oldenburg.</div>
            </div>
            <div className="row">
              <div className="col-md-2 fw-bold">bis SoSe '16</div>
              <div className="col-md-2">Uni Oldenburg</div>
              <div className="col-md-8">Tätigkeiten als Hilfskraft und Tutor in der Sprach- und Literaturdidaktik sowie der Linguistik an der Uni Oldenburg.</div>
            </div>
          </div>
        </div>

        {/* Ausbildung */}
        <div className="card shadow p-4">
          <h4 className="mb-4">Ausbildung</h4>
          <div className="border-top pt-3">
            <div className="row mb-3">
              <div className="col-md-3 fw-bold">01.10.2017 - 11.12.2023</div>
              <div className="col-md-9">
                <strong>Promotion</strong> an der Uni Oldenburg
                <div className="text-muted">"Über die Entwicklung eines (digitalen) Lesediagnose-Verfahrens zur Sichtbarmachung von Unterschieden in den hierarchieniedrigsten Lesefertigkeiten". Betreuung: Prof. Dr. Nanna Fuhrhop</div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-3 fw-bold">01.04.2015 - 30.11.2016</div>
              <div className="col-md-9">
                <strong>Masterstudium</strong> an der Uni Oldenburg
                <div className="text-muted">Master of Education für das Lehramt an Gymnasien (Deutsch / Englisch)</div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-3 fw-bold">01.10.2012 - 30.11.2016</div>
              <div className="col-md-9">
                <strong>Masterstudium</strong> an der Uni Oldenburg
                <div className="text-muted">Master of Education für das Lehramt an Grund-, Haupt- und Realschulen (Deutsch / Englisch)</div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 fw-bold">01.10.2009 - 30.09.2012</div>
              <div className="col-md-9">
                <strong>Bachelorstudium</strong> an der Uni Oldenburg
                <div className="text-muted">Bachelor of Arts (Germanistik / Anglistik)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Person;
